import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter/filter.component';
import { MatIconModule } from '@angular/material/icon';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ChipComponent } from './chip/chip.component';
import { MatChipsModule } from '@angular/material/chips';
import { ValidationsComponent } from './validations/validations.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SearchPipe } from './pipes/search.pipe';
import { DecimalPlacesPipe } from './pipes/decimal-places.pipe';
import { MatCardModule } from '@angular/material/card';
import { AttachmentViewComponent } from './attachment-view/attachment-view.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { BreadcrumbModule } from 'angular-crumbs';
import { TextMaskModule } from 'angular2-text-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { I18nModule } from '../i18n.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { SalesRoutingModule } from '../presentation/sales/sales-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { NgChartsModule } from 'ng2-charts';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReportViewPopupComponent } from './report-view-popup/report-view-popup.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { EWayTabComponent } from '../presentation/sales/e-way/e-way-tab/e-way-tab.component';
import { LastWordPipe } from './pipes/last-word.pipe';
@NgModule({
  declarations: [
    FilterComponent,
    ChipComponent,
    ValidationsComponent,
    SearchPipe,
    DecimalPlacesPipe,
    AttachmentViewComponent,
    NumbersOnlyDirective,
    ConfirmDialogComponent,
    EWayTabComponent,
    LastWordPipe
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FeatherModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatChipsModule,
    FeatherModule.pick(allIcons),
    MatTooltipModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatCardModule,
    TextMaskModule,
    BreadcrumbModule,
    InfiniteScrollModule,
    I18nModule,
    MomentDateModule,
    MatNativeDateModule,
    RouterModule,
    CdkStepperModule,
    MatGridListModule,
    MatListModule,
    MatTableModule,
    MatStepperModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRippleModule,
    MatCheckboxModule,
    SalesRoutingModule,
    MatTableModule,
    MatTabsModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatTabsModule,
    DragDropModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatDialogModule,
    TranslateModule,
    MatCheckboxModule,
    NgChartsModule,
    Ng2SearchPipeModule,
    NgxExtendedPdfViewerModule,
    TranslateModule.forChild(),
    MatButtonToggleModule,

  ],
  exports: [
    FilterComponent,
    ValidationsComponent,
    ChipComponent,
    MatTooltipModule,
    MatPaginatorModule,
    SearchPipe,
    LastWordPipe,
    DecimalPlacesPipe,
    MatIconModule,
    FeatherModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatChipsModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatCardModule,
    TextMaskModule,
    BreadcrumbModule,
    InfiniteScrollModule,
    I18nModule,
    MomentDateModule,
    MatNativeDateModule,
    RouterModule,
    CdkStepperModule,
    MatGridListModule,
    MatListModule,
    MatTableModule,
    MatStepperModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRippleModule,
    MatCheckboxModule,
    SalesRoutingModule,
    MatTableModule,
    MatTabsModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatTabsModule,
    DragDropModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatCheckboxModule,
    Ng2SearchPipeModule,
    TranslateModule,
    NumbersOnlyDirective,
    NgChartsModule,
    NgxExtendedPdfViewerModule,
    MatButtonToggleModule,
    EWayTabComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ]
})
export class SharedModule {
 
 }
